import { inputAutocomplete } from './module/inputAutocomplete.js';
import { initializeDonateForm } from './module/formHandlers.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialisiere das Autocomplete-Modul
  const inputElement = document.querySelector('[name="school_name"]');
  const dataSchoolElement = document.getElementById('schoolName');

  if (dataSchoolElement && inputElement) {
    try {
      const schoolName = JSON.parse(dataSchoolElement.textContent || '[]');
      inputAutocomplete(inputElement, schoolName);
    } catch (error) {
      console.error('Fehler beim Parsen der Schulnamen:', error);
    }
  }

  // Initialisiere das Formular
  initializeDonateForm();
});
